import { identity, mergeLeft, path, prop, propOr } from "ramda";
import { useSelector } from "react-redux";

let toastID = 0;
export const showPaidModal = message => ({ type: "ui/paid-modal/show", message });
export const hidePaidModal = () => ({ type: "ui/paid-modal/hide" });
export const addToast = message => ({ type: "ui/toast/add", message, id: ++toastID });
export const revealToast = id => ({ type: "ui/toast/reveal", id });
export const removeToast = id => ({ type: "ui/toast/remove", id });

export const useUi = () => useSelector(prop("ui"));

const handlers = {
    "ui/paid-modal/show": (state, { message }) => mergeLeft({ paid: message }, state),
    "ui/paid-modal/hide": state => mergeLeft({ paid: undefined }, state),
    "ui/toast/add": (state, { id, message }) =>
        mergeLeft({ toasts: [...state.toasts, { id, message, revealing: false }] }, state),
    "ui/toast/reveal": (state, { id }) =>
        mergeLeft(
            { toasts: [...state.toasts.map(t => (t.id == id ? { ...t, revealing: true } : t))] },
            state
        ),
    "ui/toast/remove": (state, { id }) =>
        mergeLeft(
            {
                toasts: state.toasts.reduce((toasts, t) => {
                    if (t.id != id) toasts.push(t);
                    return toasts;
                }, [])
            },
            state
        )
};

export default function reducer(state = { main: "Loading", toasts: [] }, action) {
    return propOr(identity, action.type, handlers)(state, action);
}
